/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { Button } from 'ui/atoms/Button/Button';
import { CtaSection } from 'ui/organisms/CtaSection/CtaSection';

export const InsuranceClosing = () => {
  const { t } = useInt();

  return (
    <CtaSection
      layout="split"
      glow
      animate
      title={t('Give us a hundred risks from your book. We will show you what the register says.')}
      description={t(
        'Resolved entities, group structures and the variances against your own records, sourced field by field.',
      )}
      actions={
        <>
          <Button href="/book-a-demo" type="blue" size="xl">
            {t('Book a demo')}
          </Button>
          <Button href="/contact-us" type="dark-outline" size="xl">
            {t('Talk to us')}
          </Button>
        </>
      }
    />
  );
};
